import { useState, useEffect } from 'react';

/**
 * Hook para obtener las rutas de imágenes según el equipamiento equipado
 * @returns {Object} Objeto con las rutas de las imágenes de equipamiento
 */
export const useEquipmentImages = () => {
  const [images, setImages] = useState({
    gloveHandDerecha: '/img/entrenamiento/glove-handderecha.png',
    gloveHandIzquierda: '/img/entrenamiento/glove-handizquierda.png',
    gloveFoot: '/img/entrenamiento/glove-foot.png',
    playerHead: '/img/entrenamiento/player-head.png',
    // Bonuses de equipamiento para aplicar en combate
    bonuses: { power: 0, defense: 0, speed: 0, technique: 0 },
    loading: true
  });

  useEffect(() => {
    const fetchEquipment = async () => {
      try {
        const token = localStorage.getItem('token');
        if (!token) {
          setImages(prev => ({ ...prev, loading: false }));
          return;
        }

        const response = await fetch(`${process.env.REACT_APP_API_URL}/equipment/user`, {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });

        if (!response.ok) {
          console.error('Error al obtener equipamiento');
          setImages(prev => ({ ...prev, loading: false }));
          return;
        }

        const equipment = await response.json();
        
        // Filtrar solo equipamiento equipado
        const equipped = equipment.filter(item => item.equipped);
        
        // Mapear niveles a carpetas
        const levelToFolder = {
          'starter': 'entrenamiento',
          'basic': 'basicos',
          'pro': 'pro',
          'elite': 'elite',
          'rose': 'rose',
          'military': 'military',
          'black': 'black',
          'raptors': 'raptors'
        };

        const getFolder = (item) => {
          if (!item) return 'entrenamiento';
          return levelToFolder[item.nivel] || 'entrenamiento';
        };

        // Obtener nivel de cada tipo de equipamiento
        const gloves = equipped.find(e => e.tipo === 'gloves');
        const feet = equipped.find(e => e.tipo === 'feet');
        const head = equipped.find(e => e.tipo === 'head');

        const glovesFolder = getFolder(gloves);
        const feetFolder = getFolder(feet);
        const headFolder = getFolder(head);

        // Obtener stats totales del perfil (ya incluyen base + equipo)
        let bonuses = { power: 0.1, defense: 0, speed: 0.1, technique: 0.1 };
        try {
          const profileRes = await fetch(`${process.env.REACT_APP_API_URL}/profile`, {
            headers: { 'Authorization': `Bearer ${token}` }
          });
          if (profileRes.ok) {
            const p = await profileRes.json();
            // Usar _total del perfil, capear a 100 máximo, convertir a %
            bonuses = {
              power: Math.min(100, p.fuerza_total || 10) / 100,
              defense: Math.min(100, p.defensa_total || 0) / 100,
              speed: Math.min(100, p.velocidad_total || 10) / 100,
              technique: Math.min(100, p.tecnica_total || 10) / 100
            };
          }
        } catch (e) { /* usar defaults */ }

        setImages({
          gloveHandDerecha: `/img/${glovesFolder}/glove-handderecha.png`,
          gloveHandIzquierda: `/img/${glovesFolder}/glove-handizquierda.png`,
          gloveFoot: `/img/${feetFolder}/glove-foot.png`,
          playerHead: `/img/${headFolder}/player-head.png`,
          bonuses,
          loading: false
        });

      } catch (error) {
        console.error('Error al cargar equipamiento:', error);
        setImages(prev => ({ ...prev, loading: false }));
      }
    };

    fetchEquipment();
  }, []);

  return images;
};

export default useEquipmentImages;
